require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// /Users/ddcat/project/ant-design-pro-site/ant-design-pro-site/scaffold/node_modules/_core-js@2.5.3@core-js/library/modules/es7.symbol.observable.js
// module id = 259
// module chunks = 0